import type { IMedcenter } from '@/entities/medcenter/model/types';

const generateSchedule = (): IMedcenter['schedule'] => {
  return Array.from({ length: 7 }, (_, index) => ({
    day: index,
    isWork: false,
    startTime: null,
    endTime: null,
    is24HoursWork: false,
  }));
};

export const medcenterAdapter = (medcenter: IMedcenter) => {
  return {
    ...medcenter,
    schedule: medcenter.schedule ?? generateSchedule(),
  };
};
